// extracted by mini-css-extract-plugin
export default {"title":"Maa-z","warning":"Naa-z","sizeOptionsLegendText":"Oaa-z"};